var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingsMediaUpload',{attrs:{"prop":"logo","section":"images","label":_vm.$t('_web_tournament_custom-settings_promotion_logo-label', 'Logo BG:'),"tooltip":_vm.$$t(
      'Tournament avatar, will be shown on tournament posts',
      'logo-tooltip'
    )}})}
var staticRenderFns = []

export { render, staticRenderFns }